import React from 'react';
import ReactECharts from 'echarts-for-react';

function GraphChart({ data, mapping, columnData }) {
  // Function to return a color based on the percentage from columnData
  const getNodeColor = (name, columnData) => {
    const column = columnData?.find((col) => col.columnName === name);
    return column && column.percentage < 100
      ? 'rgba(255, 99, 71, 0.9)' // Red color if percentage is less than 100
      : 'rgba(52, 152, 219, 0.7)'; // Blue color otherwise
  };

  const getMappedName = (name) => {
    switch (name) {
      case 'Date':
        return mapping.data.Date || 'Date';
      case 'Users':
        return mapping.data['Number of Unique Users'] || 'Users';
      case 'Revenue':
        return mapping.data.Revenue || 'Revenue';
      default:
        return name;
    }
  };

  // Recursive function to propagate red color to connected nodes
  const propagateColor = (currentNode, nodeMap, links) => {
    const targetLinks = links.filter((link) => link.source === currentNode.name);

    targetLinks.forEach((link) => {
      const targetNode = nodeMap[link.target];
      if (targetNode && targetNode.itemStyle.color !== 'rgba(255, 99, 71, 0.9)') {
        targetNode.itemStyle.color = 'rgba(255, 99, 71, 0.9)'; // Set red color
        propagateColor(targetNode, nodeMap, links); // Propagate to further connected nodes
      }
    });
  };

  // Update data and links based on mapping
  const updatedData = {
    ...data,
    series: [
      {
        ...data.series[0],
        // Updating node names and applying colors
        data: data.series[0].data.map((item) => {
          const newName = getMappedName(item.name);
          const color = getNodeColor(newName, columnData); // Set node color based on percentage
          return {
            ...item,
            name: newName,
            itemStyle: {
              color, // Apply the color
            },
          };
        }),
        // Updating links with mapped names
        links: data.series[0].links.map((link) => ({
          ...link,
          source: getMappedName(link.source),
          target: getMappedName(link.target),
        })),
      },
    ],
  };

  // Create a node map for easier access
  const nodeMap = updatedData.series[0].data.reduce((map, node) => {
    map[node.name] = node;
    return map;
  }, {});

  // Propagate red color through the graph
  updatedData.series[0].data.forEach((node) => {
    if (node.itemStyle.color === 'rgba(255, 99, 71, 0.9)') {
      propagateColor(node, nodeMap, updatedData.series[0].links);
    }
  });

  const option = {
    title: {
      text: updatedData.title.text,
    },
    series: [
      {
        data: updatedData.series[0].data,
        roam: false,
        type: 'graph',
        label: {
          show: true,
          fontWeight: 600,
          fontSize: 15,
          color: '#000',
        },
        links: updatedData.series[0].links,
        layout: 'none',
        edgeLabel: {
          fontSize: 20,
        },
        lineStyle: {
          color: 'source',
          width: 2,
          opacity: 0.9,
        },
        edgeSymbol: ['circle', 'arrow'],
        symbolSize: 130,
        edgeSymbolSize: [4, 10],
      },
    ],
    tooltip: {},
    animationEasingUpdate: 'quinticInOut',
    animationDurationUpdate: 1500,
  };

  return (
    <div style={{ height: '600px' }}>
      <ReactECharts option={option} style={{ height: '80%', width: '80%' }} />
    </div>
  );
}

export default GraphChart;
